(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
		if (!customElements.get('product-modal')) {
			class ProductModal extends ModalDialog {
				constructor() {
					super();
				}

				hide() {
					super.hide();
					window.pauseAllMedia();
				}

				show(opener) {
					super.show(opener);
					this.showActiveMedia();
					const lazyImages = this.querySelectorAll('.lazy-image');
					if(lazyImages.length > 0) {
						lazyImages.forEach(img => {
							this.loadImage(img)
							img.classList.remove('lazy-image');
						});
					}
				}

				loadImage = (img) => {
					img.src = img.dataset.src;
					img.srcset = img.dataset.srcset;
					img.sizes = img.dataset.sizes;
					img.classList.remove('lazy-image');
				}

				showActiveMedia() {
					this.querySelectorAll(
						`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
					).forEach((element) => {
						element.classList.remove('active');
					});
					const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
					const activeMediaTemplate = activeMedia.querySelector('template');
					const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
					activeMedia.classList.add('active');
					activeMedia.scrollIntoView();

					const container = this.querySelector('[role="document"]');
					container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

					if (
						activeMedia.nodeName == 'DEFERRED-MEDIA' &&
						activeMediaContent &&
						activeMediaContent.querySelector('.js-youtube')
					)
						activeMedia.loadContent();
				}
			}

			customElements.define('product-modal', ProductModal);
		}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('change', debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
				}, 300))
			}
		}

		customElements.define('cart-note', CartNote);
	}

  if (!customElements.get('delivery-selector')) {
    class DeliverySelector extends HTMLElement {
      constructor() {
        super();
        
        this.dateInput = this.querySelector('#delivery-date');
        this.timeInputs = this.querySelectorAll('input[name="attributes[Teslimat Saati]"]');
        this.dateError = this.querySelector('#date-error');
        this.timeError = this.querySelector('#time-error');
        this.checkoutButton = document.querySelector('#checkout');
        
        this.setupEventListeners();
        this.validateOnLoad();
      }

      setupEventListeners() {
        // Tarih değiştiğinde
        this.dateInput.addEventListener('change', () => {
          this.validateAndUpdate();
        });

        // Saat seçildiğinde
        this.timeInputs.forEach(input => {
          input.addEventListener('change', () => {
            this.validateAndUpdate();
          });
        });

        // Checkout butonuna tıklandığında
        if (this.checkoutButton) {
          this.checkoutButton.addEventListener('click', (e) => {
            if (!this.validateDelivery()) {
              e.preventDefault();
              this.showErrors();
            }
          });
        }
      }

      validateOnLoad() {
        // Sayfa yüklendiğinde mevcut değerleri kontrol et
        if (this.dateInput.value && this.getSelectedTime()) {
          this.updateCart();
        }
      }

      validateDelivery() {
        const hasDate = this.dateInput.value !== '';
        const hasTime = this.getSelectedTime() !== null;
        
        return hasDate && hasTime;
      }

      getSelectedTime() {
        const selected = Array.from(this.timeInputs).find(input => input.checked);
        return selected ? selected.value : null;
      }

      showErrors() {
        if (!this.dateInput.value) {
          this.dateError.classList.add('show');
        } else {
          this.dateError.classList.remove('show');
        }

        if (!this.getSelectedTime()) {
          this.timeError.classList.add('show');
        } else {
          this.timeError.classList.remove('show');
        }
      }

      hideErrors() {
        this.dateError.classList.remove('show');
        this.timeError.classList.remove('show');
      }

      validateAndUpdate() {
        if (this.validateDelivery()) {
          this.hideErrors();
          this.updateCart();
        }
      }

      updateCart() {
        const deliveryDate = this.dateInput.value;
        const deliveryTime = this.getSelectedTime();

        if (!deliveryDate || !deliveryTime) return;

        const body = JSON.stringify({
          attributes: {
            'Teslimat Tarihi': deliveryDate,
            'Teslimat Saati': deliveryTime
          }
        });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body }
        })
        .then(response => response.json())
        .then(data => {
          console.log('Teslimat bilgileri güncellendi:', data);
        })
        .catch(error => {
          console.error('Hata:', error);
        });
      }
    }

    customElements.define('delivery-selector', DeliverySelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
		if (!customElements.get('product-modal')) {
			class ProductModal extends ModalDialog {
				constructor() {
					super();
				}

				hide() {
					super.hide();
					window.pauseAllMedia();
				}

				show(opener) {
					super.show(opener);
					this.showActiveMedia();
					const lazyImages = this.querySelectorAll('.lazy-image');
					if(lazyImages.length > 0) {
						lazyImages.forEach(img => {
							this.loadImage(img)
							img.classList.remove('lazy-image');
						});
					}
				}

				loadImage = (img) => {
					img.src = img.dataset.src;
					img.srcset = img.dataset.srcset;
					img.sizes = img.dataset.sizes;
					img.classList.remove('lazy-image');
				}

				showActiveMedia() {
					this.querySelectorAll(
						`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
					).forEach((element) => {
						element.classList.remove('active');
					});
					const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
					const activeMediaTemplate = activeMedia.querySelector('template');
					const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
					activeMedia.classList.add('active');
					activeMedia.scrollIntoView();

					const container = this.querySelector('[role="document"]');
					container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

					if (
						activeMedia.nodeName == 'DEFERRED-MEDIA' &&
						activeMediaContent &&
						activeMediaContent.querySelector('.js-youtube')
					)
						activeMedia.loadContent();
				}
			}

			customElements.define('product-modal', ProductModal);
		}
	
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new_main-cart-items"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'change',
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, 300)
				);
			}
		}

		customElements.define('cart-note', CartNote);
	}

  if (!customElements.get('delivery-selector')) {
    class DeliverySelector extends HTMLElement {
      constructor() {
        super();
        
        this.dateInput = this.querySelector('#delivery-date');
        this.timeInputs = this.querySelectorAll('input[name="attributes[Teslimat Saati]"]');
        this.dateError = this.querySelector('#date-error');
        this.timeError = this.querySelector('#time-error');
        this.checkoutButton = document.querySelector('#checkout');
        
        this.setupEventListeners();
        this.validateOnLoad();
      }

      setupEventListeners() {
        // Tarih değiştiğinde güncelle
        this.dateInput.addEventListener('change', () => {
          this.validateAndUpdate();
        });

        // Saat seçildiğinde güncelle
        this.timeInputs.forEach(input => {
          input.addEventListener('change', () => {
            this.validateAndUpdate();
          });
        });

        // Checkout butonu tıklanınca kontrol et
        if (this.checkoutButton) {
          this.checkoutButton.addEventListener('click', (e) => {
            if (!this.validateDelivery()) {
              e.preventDefault();
              this.showErrors();
              
              // Sayfayı teslimat bölümüne kaydır
              this.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
        }
      }

      validateOnLoad() {
        // Sayfa yüklendiğinde mevcut değerleri kontrol et
        if (this.dateInput.value && this.getSelectedTime()) {
          this.updateCart();
        }
      }

      validateDelivery() {
        const hasDate = this.dateInput.value !== '';
        const hasTime = this.getSelectedTime() !== null;
        
        return hasDate && hasTime;
      }

      getSelectedTime() {
        const selected = Array.from(this.timeInputs).find(input => input.checked);
        return selected ? selected.value : null;
      }

      showErrors() {
        if (!this.dateInput.value) {
          this.dateError.classList.add('show');
        } else {
          this.dateError.classList.remove('show');
        }

        if (!this.getSelectedTime()) {
          this.timeError.classList.add('show');
        } else {
          this.timeError.classList.remove('show');
        }
      }

      hideErrors() {
        this.dateError.classList.remove('show');
        this.timeError.classList.remove('show');
      }

      validateAndUpdate() {
        if (this.validateDelivery()) {
          this.hideErrors();
          this.updateCart();
        }
      }

      formatDateForCart(dateString) {
        // YYYY-MM-DD formatını DD/MM/YYYY'ye çevir
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
      }

      updateCart() {
        const deliveryDateRaw = this.dateInput.value;
        const deliveryTime = this.getSelectedTime();

        if (!deliveryDateRaw || !deliveryTime) return;

        // Tarihi DD/MM/YYYY formatına çevir
        const deliveryDate = this.formatDateForCart(deliveryDateRaw);

        const body = JSON.stringify({
          attributes: {
            'Teslimat Tarihi': deliveryDate,
            'Teslimat Saati': deliveryTime
          }
        });

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          console.log('✅ Teslimat bilgileri kaydedildi:', data.attributes);
        })
        .catch(error => {
          console.error('❌ Hata:', error);
        });
      }
    }

    customElements.define('delivery-selector', DeliverySelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-main-cart-items"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'change',
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, 300)
				);
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old_main-cart-footer"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('change', debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
				}, 300))
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();
})();
